import { Loader } from "./Loader";

export class ImageResource {

    public imageType: string;
    private image: HTMLImageElement;
    private imagePromise: Promise<HTMLImageElement>;
    public alignedBuffer: ArrayBuffer;
    public size: number;
    public translucent: boolean;

    constructor(public reference: string) {
        
    }

    public get validImage() {
        return this.size > 0;
    }

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let mimeResult = loader.util.readString(dataView, offset);
        this.imageType = mimeResult.string;
        offset = mimeResult.offset;

        this.translucent = dataView.getUint8(offset) == 1;
        offset += 1;

        let imageSize = dataView.getInt32(offset, true);
        offset += 4;

        this.size = imageSize;

        if (imageSize > 0) {
            this.alignedBuffer = dataView.buffer.slice(dataView.byteOffset + offset, dataView.byteOffset + offset + imageSize);
        }
    }

    public async getImage(): Promise<HTMLImageElement> {

        if (!this.imagePromise) {
            this.image = new Image();
            let imageBlob = new Blob([this.alignedBuffer], { type: this.imageType });

            this.image.src = URL.createObjectURL(imageBlob);

            if (this.validImage) {

                this.imagePromise = new Promise<HTMLImageElement>((resolve, reject) => {
                    this.image.onload = (e) => {
                        resolve(this.image);
                    };
                    this.image.onerror = (e) => {
                        reject(e);
                    };
                });
            } else {
                this.imagePromise = Promise.resolve(null);
            }
        }

        return this.imagePromise;
    }
}
